import { FunctionComponent } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';

const PREFIX = 'pages.application_season.components.season_step2.qualifiers.cheat_sheet';

/**
 * Bloco explicativo abaixo dos inputs de qualifier zones. Mostra exemplos
 * reais (Brasileirão, La Liga) e o que significa "sem zona". Para usuários
 * leigos que estão configurando uma temporada pela primeira vez.
 */
export const QualifierZonesCheatSheet: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Box px={3} py={2.5} bg="gray.50" borderRadius="md" borderWidth="1px" borderColor="gray.100">
      <Flex align="center" gap={1.5} mb={1.5}>
        <ChakraFeatherIcon name="info" boxSize="12px" color="gray.500" />
        <Text fontSize="11px" fontWeight="semibold" color="gray.600" letterSpacing="wide">
          {t(`${PREFIX}.title`)}
        </Text>
      </Flex>
      <Text fontSize="11px" color="gray.600" lineHeight="1.6">
        <Text as="span" fontWeight="semibold">{t(`${PREFIX}.brasileirao_a`)}</Text>{' '}
        {t(`${PREFIX}.brasileirao_a_help`)}
      </Text>
      <Text fontSize="11px" color="gray.600" lineHeight="1.6">
        <Text as="span" fontWeight="semibold">{t(`${PREFIX}.la_liga`)}</Text>{' '}
        {t(`${PREFIX}.la_liga_help`)}
      </Text>
      <Text fontSize="11px" color="gray.600" lineHeight="1.6">
        <Text as="span" fontWeight="semibold">{t(`${PREFIX}.no_zone`)}</Text>{' '}
        {t(`${PREFIX}.no_zone_help`)}
      </Text>
    </Box>
  );
};
